


import AMC from './AMC';
import ZProps from "./zprops";
import ZLog from "./zlog";
import AMCTransactionsManagerFactory from './AMCTransactions';
import shortuuid from 'short-uuid';
const SHORTUUID = shortuuid();


export default class AMCGraph {
	constructor(graph) {
		this.graph = graph;
		this.transman = AMCTransactionsManagerFactory.manage(graph, this);
//		this.transman.setSaver((uri) => { ZUtil.throttle(uri, () => { this.save(uri, (err) => {} ) }, 1000) });
		this.nodes = [];
		this.node_uri_to_data_map = {};
		let nodes = AMC.getFlattenedService(this.graph);
		for (var i = 0; i < nodes.length; ++i) {
			let n = nodes[i];
			this.node_uri_to_data_map[n.uri] = n;
		}
	}
	getTransman() {
		return this.transman;
	}
	getPart(uri, stifle_warnings) {
		let part = this.node_uri_to_data_map[uri];
		if (!part && !stifle_warnings) {
			ZLog.error("AMCGraph.getPart - part not found: " + uri, {parts: Object.keys(this.node_uri_to_data_map)});
			// throw new Error("AMCGraph.getPart - part not found: " + uri);
		}
		return part;
	}
	simpleRemovePart(uri) {
		ZLog.debug("AMCGraph.removePart: " + uri);
		let { container, node, index } = this.getContainerNodeAndIndex(uri);
		if (node) {
			container.nodes.splice(index, 1);
			delete this.node_uri_to_data_map[uri];
			this.notify("removedPart", { uri : uri });
			return;
		}
		// not found
		throw new Error("AMCGraph.removePart - part not found: " + uri);
	}
	simpleInsertPart(part, index, container) {
		ZLog.debug("Graph.insertPart: " + part.uri + " at " + index + "in" + (container && container.uri));
		if (!part.uri || !part.kind) {
			throw new Error("Graph.insertPart - not a part: " + require("util").inspect(part));
		}
		if (this.node_uri_to_data_map[part.uri]) {
			throw new Error("Graph.insertPart - part already in graph: " + require("util").inspect(part));
		}
		this.node_uri_to_data_map[part.uri] = part;
		index !== -1 ? container.nodes.splice(index, 0, part) : container.nodes.push(part);
		this.notify("insertedNode", { node: part, index: index });
	}
	// literal indexing is true for undo, redo 
	simpleMovePart(part, new_index, old_index, container) {
		// moved index will be removed, so indexes of parts after it are reduced by 1
		//if (!literal && new_index > old_index) {
			//--new_index;
		//}
		ZLog.debug("Graph.simpleMovePart old_index=" + old_index + ",new_index=" + new_index);
		container.nodes.splice(old_index, 1)
		container.nodes.splice(new_index, 0, part)
	}
	rebuild() {
	}
	// new_part or new_part_uri
	insertNewPart(current_uri, new_part, before=true) {
		let { container, node, index } = this.getContainerNodeAndIndex(current_uri);
		if (!container || !node) {
			throw new Error("Graph.insertNewPart - part not found: " + current_uri);
		}
		let id = this.transman.startTransaction("user paste insert " + (before ? "before" : "after"));
		new_part = typeof new_part === "string" ? ZProps.get(new_part) : new_part;
		new_part.uri = this.genUniquePartURI(new_part);
		// not for dnd out of pile new_part.name = this.genUniquePartName(new_part.name, 0);
		new_part.name = new_part.name || new_part.type.split("/")[2];
		this.transman.createPart(new_part, before ? index : index + 1, container);
		this.transman.endTransaction(id);
//		ZNetwork.post("history", current_uri);
		// caller to rebuild graph...
		return new_part.uri;
	}
	movePart(target_uri, moved_uri, before=true) {
		let { container, node, index } = this.getContainerNodeAndIndex(target_uri);
		if (!container || !node) {
			throw new Error("Graph.movePart - part not found: " + target_uri);
		}
		let target_index = index;
		let moved_index;
		{
			let { index } = this.getContainerNodeAndIndex(moved_uri);
			moved_index = index;
		}
		// moved index will be removed, so indexes of parts after it are reduced by 1
console.log("movePart at before= " + before + ", target_index: " + target_index + ", moved_index=" + moved_index);
		if (target_index > moved_index) {
			--target_index;
		}
console.log("now movePart at before= " + before + ", target_index: " + target_index + ", moved_index=" + moved_index);
		let id = this.transman.startTransaction("user move part " + (before ? "before" : "after"));
		let moved_part = ZProps.get(moved_uri);
		this.transman.movePart(moved_part, before ? target_index : target_index + 1, moved_index, container);
		this.transman.endTransaction(id);
//		ZNetwork.post("history", moved_uri);
		// caller to rebuild graph...
	}
	getContainerNodeAndIndex(current_uri, container) {
		container = container || this.graph;
		for (let i = 0; i < container.nodes.length; ++i) {
			let n = container.nodes[i];
			if (n.uri === current_uri) {
				return { container: container, node: n, index: i };
			}
			if (n.nodes) {
				let results = this.getContainerNodeAndIndex(current_uri, n);
				if (results.node) {
					return results;
				}
			}
		}
		return { container: null, node: null, index: -1 };
	}
	replacePart(current_uri, new_uri) {
		let { container, node, index } = this.getContainerNodeAndIndex(current_uri);
		if (!container || !node) {
			throw new Error("Graph.replacePart - part not found: " + current_uri);
		}
		//this.dump("Before replace");
		let id = this.transman.startTransaction("user drag and drop replacement");
		this.transman.destroyPart(current_uri);
		// this.dump("After delete " + current_uri);
		let new_part = typeof new_uri === "string" ? ZProps.get(new_uri) : new_uri;
		new_part.uri = this.genUniquePartURI(new_part);
		this.transman.createPart(new_part, index, container);
		// this.dump("After create new node " + new_uri);
		this.transman.endTransaction(id);
//		ZNetwork.post("history", current_uri);
		return new_part.uri;
	}
	removePart(current_uri) {
		let { container, node } = this.getContainerNodeAndIndex(current_uri);
		if (!container || !node) {
			throw new Error("Graph.replacePart - part not found: " + current_uri);
		}
		//this.dump("Before replace");
		let id = this.transman.startTransaction("user remove part");
		this.transman.destroyPart(current_uri);
		this.transman.endTransaction(id);
//		ZNetwork.post("history", current_uri);
	}
/*
	getPartIndex(uri) {
		let list = this.graph.nodes;
		for (let i = 0; i < list.length; ++i) {
			if (list[i].uri === uri) {
				return i;
			}
		}
		throw new Error("AMCGraph.getPartIndex - part not found: Use getContainerNodeAndIndex." + uri);
	}
*/
	genUniquePartURI(part) {
		return part.kind + "_" + SHORTUUID.generate();
	}
/*
	genUniquePartURI_old(root, iteration) {
		let attempt = root + "-" + iteration;
		if (root.lastIndexOf("-") !== -1 && ZUtil.isInteger(root.substring(root.lastIndexOf("-") + 1))) {
			attempt = root.substring(0, root.lastIndexOf("-")) + "-" + iteration;
		}
		if (this.getPart(attempt, true)) {
			return this.genUniquePartURI(root, iteration + 1);
		}
		return attempt;
	}
*/
	genUniquePartName(orig) {
		if (orig === "placeholder") {
			return orig;
		}
		let names = {};
		for (let i = 0; i < this.nodes.length; ++i) {
			names[this.nodes[i].model.name] = true;
		}
		let iterator = 0;
		while (iterator < 1000) {
			let name = orig + " (copy" + (iterator === 0 ? "" : " " + iterator) + ")";
			if (!names[name]) {
				return name;
			}
			++iterator;
		}
		ZLog.error("RockApplication - genUniquePartName - no free name found: " + orig);
		return orig;
	}
	getURI() {
		return this.graph.uri;
	}
	getOps() {
		return this.graph.ops;
	}
	setOps(ops) {
		this.graph.ops = ops;
	}
	getGraph() {
		return this.graph;
	}
	getApp() {
		return this.graph;
	}
	getParts() {
		return this.graph.nodes.slice();
	}
	// include placeholders and pipelines
	getAllParts() {
		return this.graph.nodes.slice();
	}
	setListener(listener) {
		this.listener = listener;
	}
	notify(command, context) {
		if (this.listener) {
			this.listener(command, context);
		}
	}
/*
	save(graph_uri, callback) {
		let bundle = AMC.serialize(this.graph);
//return; // TESTTT
		ZNetwork.post("thing", this.graph.uri, null, { data: bundle }, function(err) {
			ZProps.set("service:changed:" + bundle.uri, Date.now());
			if (callback) {
				callback(err);
			}
		});
	}
*/
}



// WEBPACK FOOTER //
// ./src/AMCGraph.js